import type { TFunction } from 'i18next';

import { EGoalType } from '@feathr/blackbox';

export interface IGoalTypeOption {
  id: EGoalType;
  name: string;
  description: string;
}

export const getGoalTypeOptions = (t: TFunction): IGoalTypeOption[] => [
  {
    id: EGoalType.page_view,
    name: t('URL Visit'),
    description: t('Track when a person visits a specific URL'),
  },
  {
    id: EGoalType.group_entry,
    name: t('Group entry'),
    description: t('Track when a person enters a specific group'),
  },
  {
    id: EGoalType.conversion_pixel,
    name: t('Conversion Pixel Trigger'),
    description: t('Track when a conversion pixel is triggered'),
  },
  {
    id: EGoalType.form_submission,
    name: t('Form Submission'),
    description: t('Track when a person submits a form'),
  },
  {
    id: EGoalType.donation_form_submission,
    name: t('Donation Form Submission'),
    description: t('Track when a person submits a donation form'),
  },
];
